import { withSvgProps } from './helpers'
import { ReactComponent as SvgComponent } from './svg/term-life-icon.svg'

type SvgProps = React.ComponentProps<typeof SvgComponent>

const Svg: React.FC<SvgProps> = (props) => <SvgComponent {...props} />

export const TermLifeIcon = withSvgProps(Svg)
